import { DraggableFilterType } from '../../../../constants';
import { ListViewMode } from '../../constants';

export enum TransportManagementFilterName {
  ActualArrivalTimeLoad = 'actualArrivalTimeLoad',
  ActualArrivalTimeTOAndWaybill = 'actualArrivalTimeTOAndWaybill',
  ActualDepartureTimeLoad = 'actualDepartureTimeLoad',
  ActualDepartureTimeTOAndWaybill = 'actualDepartureTimeTOAndWaybill',
  CarrierTOs = 'carrierTOs',
  Carriers = 'carriers',
  CommercialInvoiceNumbers = 'commercialInvoiceNumbers',
  Consignees = 'consignees',
  Consignors = 'consignors',
  DeliveryNoteNumbers = 'deliveryNoteNumbers',
  DeliveryServices = 'deliveryServices',
  DeviationTypes = 'deviationTypes',
  DeviationHours = 'deviationHours',
  EquipmentIds = 'equipmentIds',
  EstimatedArrivalTimeLoad = 'estimatedArrivalTimeLoad',
  EstimatedArrivalTimeTOAndWaybill = 'estimatedArrivalTimeTOAndWaybill',
  EstimatedDepartureTimeLoad = 'estimatedDepartureTimeLoad',
  EstimatedDepartureTimeTOAndWaybill = 'estimatedDepartureTimeTOAndWaybill',
  FlightNumbers = 'flightNumbers',
  FreightModes = 'freightModes',
  GBs = 'gbs',
  HouseAirwayBills = 'houseAirwayBills',
  HouseBillOfLadings = 'houseBillOfLadings',
  InboundPlants = 'inboundPlants',
  IStarNumbers = 'iStarNumbers',
  LoadNumbers = 'loadNumbers',
  MasterAirWaybills = 'masterAirWaybills',
  MasterBillOfLadings = 'masterBillOfLadings',
  MaterialNumbers = 'materialNumbers',
  MRPControllers = 'mrpControllers',
  Origins = 'origins',
  Pickups = 'pickups',
  PlannedArrivalTimeLoad = 'plannedArrivalTimeLoad',
  PlannedArrivalTimeTOAndWaybill = 'plannedArrivalTimeTOAndWaybill',
  PlannedDepartureTimeLoad = 'plannedDepartureTimeLoad',
  PlannedDepartureTimeTOAndWaybill = 'plannedDepartureTimeTOAndWaybill',
  PurchaseOrderNumbers = 'purchaseOrderNumbers',
  ReasonCodes = 'reasonCodes',
  ServiceLevels = 'serviceLevels',
  ShipTos = 'shipTos',
  StatusCodes = 'statusCodes',
  Statuses = 'statuses',
  TrailerPlates = 'trailerPlates',
  TransportModes = 'transportModes',
  TransportOrderNumbers = 'transportOrderNumbers',
  TruckPlates = 'truckPlates',
  VesselNames = 'vesselNames',
  Waybills = 'waybills',
}

export const TRANSPORT_MANAGEMENT_FILTER_TYPE_BY_NAME: Map<TransportManagementFilterName, DraggableFilterType> =
  new Map([
    [TransportManagementFilterName.TransportOrderNumbers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.EquipmentIds, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.LoadNumbers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.MaterialNumbers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.DeliveryNoteNumbers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.HouseAirwayBills, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.IStarNumbers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.TransportModes, DraggableFilterType.MultipleSelect],
    [TransportManagementFilterName.Origins, DraggableFilterType.MultipleSelect],
    [TransportManagementFilterName.Statuses, DraggableFilterType.MultipleSelect],
    [TransportManagementFilterName.FreightModes, DraggableFilterType.MultipleSelect],
    [TransportManagementFilterName.ServiceLevels, DraggableFilterType.MultipleSelect],
    [TransportManagementFilterName.DeliveryServices, DraggableFilterType.MultipleSelect],
    [TransportManagementFilterName.DeviationTypes, DraggableFilterType.MultipleSelect],
    [TransportManagementFilterName.DeviationHours, DraggableFilterType.Input],
    [TransportManagementFilterName.GBs, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.MRPControllers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.Carriers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.Pickups, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.ShipTos, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.Consignors, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.Consignees, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.ReasonCodes, DraggableFilterType.ChipsInputPopup],
    [TransportManagementFilterName.StatusCodes, DraggableFilterType.ChipsInputPopup],
    [TransportManagementFilterName.HouseBillOfLadings, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.MasterAirWaybills, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.MasterBillOfLadings, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.CarrierTOs, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.CommercialInvoiceNumbers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.PurchaseOrderNumbers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.TruckPlates, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.TrailerPlates, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.FlightNumbers, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.VesselNames, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.Waybills, DraggableFilterType.ChipsInput],
    [TransportManagementFilterName.InboundPlants, DraggableFilterType.ChipsInputSearch],
    [TransportManagementFilterName.EstimatedDepartureTimeLoad, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.EstimatedDepartureTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.EstimatedArrivalTimeLoad, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.EstimatedArrivalTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.ActualDepartureTimeLoad, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.ActualDepartureTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.ActualArrivalTimeLoad, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.ActualArrivalTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.PlannedDepartureTimeLoad, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.PlannedDepartureTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.PlannedArrivalTimeLoad, DraggableFilterType.RangeDatepicker],
    [TransportManagementFilterName.PlannedArrivalTimeTOAndWaybill, DraggableFilterType.RangeDatepicker],
  ]);

export const TransportManagementEntity = {
  ...ListViewMode,
};
